import { MessageBar, MessageBarType } from "@fluentui/react";
import React, { useContext } from "react";
import { Stack } from "sprint-common-web";

import { OrderDashboardItem } from "../OrderDashboardItem";
import { OrderDashboardContext } from "../provider/OrderDashboardContext";

export const OrderWarningSection = (): JSX.Element => {
    const { orderDashboardItem, isLoading } = useContext(OrderDashboardContext);

    if (isLoading) {
        return <></>;
    }

    const warnings = getWarnings(orderDashboardItem);

    if (warnings.length === 0) {
        return <></>;
    }

    return <Stack style={{ padding: 10 }}>{warnings}</Stack>;
};

const getWarnings = (item: OrderDashboardItem): JSX.Element[] => {
    const warnings: JSX.Element[] = [];

    if (isResolutionVarying(item)) {
        warnings.push(resolutionWarning(item));
    }

    return warnings;
};

const isResolutionVarying = (item: OrderDashboardItem) => {
    const { metadata, targetResolution } = item;

    if (!metadata || !targetResolution) {
        return false;
    }

    return metadata.width !== targetResolution.width || metadata.height !== targetResolution.height;
};

const resolutionWarning = (item: OrderDashboardItem): JSX.Element => {
    return (
        <MessageBar key="resolution-warning" messageBarType={MessageBarType.warning}>
            <div>{"Encoded video file resolution does not match the order's target resolution."}</div>
            <div>{`Encoded video file resolution: ${item.metadata?.width}x${item.metadata?.height}`}</div>
            <div>{`Target resolution: ${item.targetResolution?.width}x${item.targetResolution?.height}`}</div>
        </MessageBar>
    );
};
